module.exports = __webpack_public_path__ + "img/9.22a80eaf.png";